import { LngLatBounds } from 'mapbox-gl';

export type MapboxStyleType = 'streets' | 'satellite';

export const MAPBOX_STYLE: Record<MapboxStyleType, string> = {
  streets: 'mapbox://styles/marcos-pastor/cmig8ow8e004001qwgxo5azfa',
  satellite: 'mapbox://styles/mapbox/satellite-v9',
};

export const DEFAULT_MAP_BOUNDS = new LngLatBounds([
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  [-26, 36], // NOTE: SW, Atlantic Ocean
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  [45, 60], // NOTE: NE, Finland - Russian border
]);
